import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { color, gutter } from '../../styles/mixins';
import { Container } from '../container/container';

const Host = styled.div`
  padding-bottom: ${gutter(8)};
`;

const Children = styled.div`
  margin-bottom: ${gutter(4)};
`;

const Action = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 100%
  );
  padding-bottom: ${gutter(2)};
  padding-top: 128px;
  pointer-events: none;
  > * {
    pointer-events: auto;
  }
  @media ${device.desktop} {
    display: none;
  }
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${gutter(2)};

  font-size: 12px;
  line-height: 1em;

  p {
    margin-top: 2px;
  }
`;

const Box = styled.div`
  height: 14px;
  width: 14px;
  margin-right: ${gutter(1)};

  background-color: ${color('green20')};

  flex-shrink: 0;
`;

interface LeaderBoardViewProps {
  children: React.ReactNode;
  action?: React.ReactNode;
  hasBid?: boolean;
}

export const LeaderBoardView = ({
  children,
  action,
  hasBid,
}: LeaderBoardViewProps) => {
  return (
    <Host>
      <Children>
        {children}
        {hasBid && (
          <Description>
            <Box />
            <p>Highlighted bids are your current winning bids</p>
          </Description>
        )}
      </Children>

      {action && (
        <Action>
          <Container>{action}</Container>
        </Action>
      )}
    </Host>
  );
};
